import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  RSelect,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { GET, POST } from "../../helper/api";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { BILL_TYPE, DRAFF_BILL_FILTER_DUPLIDATE } from "../../utils/Utils";

const BILL_TYPE_OPTIONS = Object.keys(BILL_TYPE).map((c) => ({
  label: BILL_TYPE[c],
  value: c,
}));

const DRAFF_BILL_FILTER_DUPLIDATE_OPTIONS = Object.keys(DRAFF_BILL_FILTER_DUPLIDATE).map((c) => ({
  label: DRAFF_BILL_FILTER_DUPLIDATE[c],
  value: c,
}));



const DraffBillManager = () => {
  const [data, setData] = useState([]);

  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [billId, setBillId] = useState(null)
  const [rangeDate, setRangeDate] = useState({
    startDate: searchParams.get('startDate') ? moment(searchParams.get('startDate')).startOf('days').toDate() : moment(undefined).add(-7, 'days').startOf('days').toDate(),
    endDate: moment(searchParams.get('endDate') || undefined).endOf('days').toDate(),
  });

  const [filter, setFilter] = useState({
    customerId: searchParams.get('customerId') || undefined,
    warehouseId: searchParams.get('warehouseId') || undefined,
    type: searchParams.get('type') || undefined,
    ingredientId: searchParams.get('ingredientId') || undefined,
    excludeExistBill: searchParams.get('excludeExistBill') || DRAFF_BILL_FILTER_DUPLIDATE_OPTIONS[1].value,
  });
  const [customerOptions, setCustomerOptions] = useState([]);
  const [ingredientOptions, setIngredientOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [view, setView] = useState({
    convert: false,
  });

  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };


  // function to close the form modal
  const onFormCancel = () => {
    setView({ convert: false });
    setBillId(null);
  };

  const convertToBill = () => {
    setLoading(true)
    const convertingId = billId;
    // Phiếu cân gia công (có KH thuê gia công) được tạo thành đơn nhận gia công
    const isProcessingDraff = !!data.find((e) => e.id === convertingId)?.isProcessing;
    POST(`/draff-app-bill/convert-to-bill/${convertingId}`, {}, {}, true)
      .then((res) => {
        if (isProcessingDraff) {
          toast.success("Tạo đơn nhận gia công thành công");
          history.push(`/processing-bill/${convertingId}`);
          return;
        }
        toast.success("Tạo đơn thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false)
      })
  };

  const colTable = [
    {
      Header: "Mã",
      accessor: "id",
    },
    {
      Header: "Khách hàng",
      accessor: (item) => item?.customerName,
    },
    {
      Header: "Biển số xe",
      accessor: (item) => item?.truckId || "",
    },
    {
      Header: "Loại",
      accessor: (item) => item.typeName,
    },
    {
      Header: "Hàng hoá",
      accessor: (item) => item?.ingredientName,
    },
    {
      Header: "Khối lượng tổng(kg)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item.totalWeight}
        displayType={'text'}
        decimalScale={2}
        thousandSeparator={','}
        thousandsGroupStyle="thousand"
      />
    },
    {
      Header: "Khối lượng xe(kg)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item.truckWeight}
        displayType={'text'}
        decimalScale={2}
        thousandSeparator={','}
        thousandsGroupStyle="thousand"
      />
    },
    {
      Header: "Khối lượng hàng(kg)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item.merchandiseWeight}
        displayType={'text'}
        decimalScale={2}
        thousandSeparator={','}
        thousandsGroupStyle="thousand"
      />
    },
    {
      Header: "Giờ vào",
      accessor: (item) => item.scaleWeightFirstTimesAt,
    },
    {
      Header: "Giờ ra",
      accessor: (item) => item.scaleWeightSecondTimesAt,
    },
    {
      Header: "Ghi chú",
      accessor: (item) => item.note
    },
    {
      Header: "Hành cộng",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  {
                    ['IN', 'OUT'].includes(item.type) ? <li>
                      <DropdownItem
                        tag="a"
                        href="#edit"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setBillId(item.id);
                          toggle("convert");
                        }}
                      >
                        <Icon
                          name={"eye"}
                        ></Icon>
                        <span>
                          Tạo đơn
                        </span>
                      </DropdownItem>
                    </li> : <></>
                  }

                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.ingredientId ? { ingredientId: filter.ingredientId } : {}),
      ...(filter.excludeExistBill ? { excludeExistBill: filter.excludeExistBill } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    getData();
  }, [timeNow, filter]);

  const getData = () => {
    setLoading(true);
    setData([]);
    let params = {
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.ingredientId ? { ingredientId: filter.ingredientId } : {}),
      ...(filter.excludeExistBill ? { excludeExistBill: filter.excludeExistBill } : {}),
    };

    GET(`/draff-app-bill`, params, true)
      .then(({ data }) => {
        const rows = data?.rows || [];
        setData([...rows]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    GET("ingredient", {}, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setIngredientOptions(
          data.rows.map((c) => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        );
      }
    });


    GET("customer", {}, true).then((resp) => {
      setCustomerOptions(
        resp.data?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });

    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, []);


  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };


  const exportExcel = () => {
    const params = new URLSearchParams({
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.ingredientId ? { ingredientId: filter.ingredientId } : {}),
      ...(filter.excludeExistBill ? { excludeExistBill: filter.excludeExistBill } : {}),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/draff-app-bill/find-all-excel?${params.toString()}`;
    window.open(url, '_blank')
  };
  return (
    <React.Fragment>
      <Head title="Quản lý đơn hàng"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đơn hàng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          placeholder='Lọc đơn'
                          options={DRAFF_BILL_FILTER_DUPLIDATE_OPTIONS}
                          value={DRAFF_BILL_FILTER_DUPLIDATE_OPTIONS.find((c) => c.value === filter.excludeExistBill)}
                          onChange={(val) => setFilter({
                            ...filter,
                            excludeExistBill: val?.value,

                          })}
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <RSelect
                            isClearable
                            placeholder={"Lọc theo kho"}
                            options={warehouseOptions}
                            value={warehouseOptions.find((c) => c.value === filter.warehouseId) || null}
                            onChange={(val) => {
                              setFilter({
                                ...filter,
                                warehouseId: val?.value || undefined,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Khách hàng/Nhà cung cấp"
                          options={customerOptions}
                          value={
                            customerOptions.find(
                              (c) => c.value == filter.customerId
                            ) || ""
                          }
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              customerId: val?.value || undefined,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          isClearable
                          placeholder='Loại'
                          options={BILL_TYPE_OPTIONS}
                          value={BILL_TYPE_OPTIONS.find((c) => c.value === filter.type)}
                          onChange={(val) => setFilter({
                            ...filter,
                            type: val?.value || undefined,
                          })}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          isClearable
                          placeholder='Hàng hoá'
                          options={ingredientOptions}
                          value={ingredientOptions.find((c) => c.value === filter.ingredientId)}
                          onChange={(val) => setFilter({
                            ...filter,
                            ingredientId: val?.value || undefined,
                          })}
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button
                          color="secondary"
                          onClick={exportExcel}
                        >
                          <span>Xuất excel</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <Table
                    notShowPagi
                    loading={loading}
                    columns={colTable}
                    data={data}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

      </Content>
      <Modal isOpen={view.convert} toggle={() => onFormCancel()}>
        <ModalBody className="modal-body-lg text-center">
          <div className="nk-modal">

            <h4 className="nk-modal-title">
              Bạn có chắc muốn tạo đơn hàng này không ?{" "}
            </h4>
            <div className="nk-modal-action mt-5 d-flex justify-content-around">
              <Button
                color="light"
                size="lg"
                className="btn-mw mr-5"
                onClick={() => onFormCancel()}
              >
                Huỷ bỏ
              </Button>
              <Button
                color="primary"
                size="lg"
                className="btn-mw"
                onClick={(ev) => {
                  ev.preventDefault();
                  convertToBill();
                }}
              >
                Xác nhận
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default DraffBillManager;
